import { toJS } from 'mobx';
import { useCountryCode } from 'petdna-lib-uicomponents/hooks';
import { ForProject } from 'petdna-lib-uicomponents/hygraph';
import { useEffect } from 'react';
import { useStores } from 'stores/useStores';

export const useLoadSiteFooter = () => {
  const {
    pagesStore,
    testsStore: { petProfiles },
    sessionStore: { sessionValid },
  } = useStores();
  const countryCode = useCountryCode(true);

  useEffect(() => {
    if (!countryCode) return undefined;

    const hasPets = (sessionValid && petProfiles) && toJS(petProfiles).length !== 0;
    const forProject: ForProject = hasPets ? ForProject.LIHP : ForProject.LOHP;

    const timeout = setTimeout(() => {
      pagesStore.getSiteFooter(countryCode, forProject);
    }, 1000);

    return () => {
      clearTimeout(timeout);
    };
  }, [countryCode, pagesStore, petProfiles, sessionValid]);

  return { footerData: pagesStore?.footerData };
};
